// Copyright (c) Microsoft Corporation. All rights reserved.

export default class WegoAuthUser {
    userId: string;
    userPrincipalName: string;

    constructor(userId: string, userPrincipalName: string) {
        this.userId = userId;
        this.userPrincipalName = userPrincipalName;
    }
}